import React from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import "@ant-design/compatible/assets/index.css";
import {
  Select,
  Input,
  Button,
  Collapse,
  Checkbox,
  Badge,
  DatePicker,
  Tooltip,
  Icon,
} from "antd";
import { Form } from "@ant-design/compatible";
import moment from "moment";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import { QuestionCircleOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Panel } = Collapse;
const { RangePicker } = DatePicker;
const formTailLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 8,
    offset: 5,
  },
};

function range(start, end) {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
}

function disabledDate(current) {
  // Can not select days before today and today
  return current && current < moment().endOf("day");
}

function disabledDateTime() {
  return {
    disabledHours: () => range(0, 24).splice(4, 20),
    disabledMinutes: () => range(30, 60),
    disabledSeconds: () => [55, 56],
  };
}

function disabledRangeTime(_, type) {
  if (type === "start") {
    return {
      disabledHours: () => range(0, 60).splice(4, 20),
      disabledMinutes: () => range(30, 60),
      disabledSeconds: () => [55, 56],
    };
  }
  return {
    disabledHours: () => range(0, 60).splice(20, 4),
    disabledMinutes: () => range(0, 31),
    disabledSeconds: () => [55, 56],
  };
}
class Notifications extends React.Component {
  constructor() {
    super();
  }
  state = {
    hmg_ids: [],
    notification_title: "",
    notification_type: "success",
    trigger_date_time: undefined,
    description: "",
    go_live: false,
    enable_on_dashboard: false,
  };

  componentDidMount = async () => {
    await this.props.hmgGet();
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const hmgs = this.state.hmg_ids;
        const title = this.props.form.getFieldValue("title");
        const type = this.props.form.getFieldValue("type");
        const trigger_date_time =
          this.props.form.getFieldValue("trigger_date_time");
        const description = this.props.form.getFieldValue("description");
        const go_live = this.props.form.getFieldValue("go_live");
        const enable_on_dashboard = this.props.form.getFieldValue(
          "enable_on_dashboard"
        );

        //this.setState({sortedInfo:{order:order, columnKey:sort}});
        await this.props.notificationCreate({
          hmg_ids: hmgs,
          notification_title: title,
          notification_type: type,
          trigger_date_time: trigger_date_time,
          description: description,
          go_live: go_live,
          enable_on_dashboard: enable_on_dashboard,
        });
      }
    });
  };
  handleHmgChange = async (e) => {
    await this.props.notificationSetHmg(e);
    const hmg_list = this.props.notifications_api.hmgListSelected;
    this.setState({ hmg_ids: hmg_list });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 12 }}
        onSubmit={this.handleSubmit}
      >
        <div className="container_ab">
          <Collapse defaultActiveKey={["1"]} expandIconPosition={"right"}>
            <Panel header="SSO Notifications" key="1">
              <Form.Item
                label={
                  <span>
                    Hmg&nbsp;
                    <Tooltip title="Leave this field blank to select all management groups or select certain one(s)">
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </span>
                }
              >
                {getFieldDecorator("hmg")(
                  <Select
                    showSearch
                    placeholder="Please Select Hotel Management Group"
                    onChange={async (e) => {
                      await this.handleHmgChange(e);
                    }}
                    mode={"multiple"}
                    showSearch
                    value={this.props.hmgSelect}
                    style={{ width: "100%", maxWidth: "450px" }}
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {this.props.api.hmgGetData !== null
                      ? this.props.api.hmgGetData.data.map((elem) => {
                          return (
                            <Option key={elem._id} value={elem._id}>
                              {elem.hmg_name}
                            </Option>
                          );
                        })
                      : null}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="Notification Title">
                {getFieldDecorator("title", {
                  rules: [
                    {
                      required: true,
                      message: "Please insert notification title!",
                    },
                  ],
                })(<Input />)}
              </Form.Item>
              <Form.Item label="Notification Type">
                {getFieldDecorator("type", {
                  rules: [
                    {
                      required: true,
                      message: "Please select notification type!",
                    },
                  ],
                })(
                  <Select placeholder="Select notification type">
                    <Option value="success">
                      <Badge status="success" text="Success" />
                    </Option>
                    <Option value="processing">
                      <Badge status="processing" text="Processing" />
                    </Option>
                    <Option value="warning">
                      <Badge status="warning" text="Warning" />
                    </Option>
                    <Option value="error">
                      <Badge status="error" text="Error" />
                    </Option>
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="Date and Time to trigger notification">
                {getFieldDecorator("trigger_date_time")(
                  <DatePicker
                    format="YYYY-MM-DD HH:mm:ss"
                    disabledDate={disabledDate}
                    disabledTime={disabledDateTime}
                    showTime={{ defaultValue: moment("00:00:00", "HH:mm:ss") }}
                  />
                )}
              </Form.Item>

              <Form.Item name="Introduction" label="Description">
                {getFieldDecorator("description", {
                  rules: [
                    { required: true, message: "Descriptions is required!" },
                  ],
                })(<Input.TextArea />)}
              </Form.Item>
              <Form.Item {...formTailLayout}>
                {getFieldDecorator("go_live", {
                  initialValue: false,
                })(<Checkbox onChange={this.handleChange}>Go live.</Checkbox>)}
              </Form.Item>
              <Form.Item {...formTailLayout}>
                {getFieldDecorator("enable_on_dashboard", {
                  initialValue: false,
                })(
                  <Checkbox onChange={this.handleChange}>
                    Enable notifications on dashboard.
                  </Checkbox>
                )}
              </Form.Item>
              <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Panel>
          </Collapse>
        </div>
      </Form>
    );
  }
}

const WrappedApp = Form.create({ name: "notification" })(Notifications);
const mapStateToProps = (state) => {
  return {
    api: state.api,
    notifications_api: state.notifications,
  };
};
const mapDispatchToProps = (dispatch) => ({
  hmgGet: () => dispatch(actions.hmgGet()),
  notificationCreate: (data) => dispatch(actions.notificationCreate(data)),
  notificationSetHmg: (data) => dispatch(actions.notificationSetHmg(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(WrappedApp);
